<template>
  <div>
    <div v-if="loadingItemLotMovements && (!itemLotMovements || !itemLotMovements.length)" class="mb-5 pb-5">
      <loading-animation />
    </div>

    <div v-if="!loadingItemLotMovements && (!itemLotMovements || !itemLotMovements.length)" class="mb-3">
      <div class="row bg-light py-3">
        <div class="col text-center">
          Nenhum movimento encontrado
        </div>
      </div>
    </div>

    <div v-if="!loadingItemLotMovements && itemLotMovements && itemLotMovements.length" class="mb-3 mx-n3">
      <div v-for="(itemLotMovement, index) in itemLotMovements" class="row py-3 border mx-0 align-items-lg-end align-items-start"
        :key="index" :class="{ 'bg-light': index % 2 != 0}">
        <div class="col-lg-9 col-sm-7 col-12">
          <div class="row">
            <div class="col-xl-4 col-sm-12 col-12">
              <span  class="font-weight-bold">Data: </span>
              {{itemLotMovement.formattedDate}}
            </div>
            <div class="col-xl-4 col-lg-6 col-12">
              <span  class="font-weight-bold">Número do Lote: </span>
              <text-highlight :queries="foundBalances && foundBalances.length ? suggestionsLotPrefixes : []">
                {{itemLotMovement.itemLot ? itemLotMovement.itemLot.lotNumber : '' }}
              </text-highlight>
            </div>
            <div class="col-xl-4 col-lg-6 col-12">
              <span  class="font-weight-bold">Endereço: </span>
              {{itemLotMovement.location ? itemLotMovement.location.name : '' }}
            </div>
          </div>
        </div>
        <div class="col-lg-3 col-sm-5 col-12">
          <span  class="font-weight-bold">Quantidade: </span>
          <composite-item-lot-quantity
            :quantity="itemLotMovement.quantity"
            :itemLot="itemLotMovement.itemLot"
          ></composite-item-lot-quantity>
        </div>
        <div v-if="itemLotMovement.doesNotBelongToSuggestions" class="col-12 text-danger font-weight-bold mt-1">
          <i class="fa fa-exclamation-triangle"></i> Não pertence à sugestão
        </div>
      </div>

      <div v-if="loadingItemLotMovements" class="mb-5 pb-5">
        <loading-animation />
      </div>

      <div v-if="isItemLotMovementsLastPage" class="row justify-content-center mt-2">
        <div class="col-sm-auto col-12">
          <b-button variant="secondary" @click.prevent="loadNextItemLotMovements()" class="mobile-btn-100">
            Carregar movimentos mais antigos
          </b-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { LoadingAnimation } from '@/components/loaders';
import CompositeItemLotQuantity from '@/components/common/composite-item-lot-quantity';
import TextHighlight from 'vue-text-highlight';

export default {
  name: 'finished-movements-table',
  components: { LoadingAnimation, CompositeItemLotQuantity, TextHighlight },

  props: {
    loadingItemLotMovements: {
      type: Boolean
    },
    itemLotMovements: {
      type: Array
    },
    foundBalances: {
      type: Array
    },
    isItemLotMovementsLastPage: {
      type: Boolean
    },
    loadNextItemLotMovements: {
      type: Function,
      default () {
        return;
      }
    },
    suggestionsLotPrefixes: {
      type: Array
    }
  }
}
</script>
